import { postLikeFolder } from './postLikeFolder';
import { getLikedFolders } from './getLikedFolders';
import { deleteLikedFolder } from './deleteLikedFolder';
import { putLikedFolder } from './putLikedFolder';
import { editLikedFoldersOrder } from './editLikedFoldersOrder';

export const likedFolderService = {
  get: getLikedFolders,
  post: postLikeFolder,
  put: putLikedFolder,
  delete: deleteLikedFolder,
  editOrder: editLikedFoldersOrder,
};
